// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogPostPage_container__vuom3","content":"BlogPostPage_content__ofn_C"};